/**
 * Estilo consistente para exibir confiança do OCR de placas (dashboard, relatórios).
 */
export function ocrConfidenceStyle(pct: number | null): {
  label: string;
  className: string;
} {
  if (pct == null || !Number.isFinite(pct)) {
    return {
      label: 'OCR —',
      className: 'border border-zinc-500/40 bg-zinc-800/50 text-zinc-400',
    };
  }
  const p = Math.round(Math.min(100, Math.max(0, pct)));
  if (p >= 78) {
    return {
      label: `OCR ${p}%`,
      className:
        'border border-emerald-500/40 bg-emerald-500/10 text-emerald-200 shadow-[0_0_12px_rgba(16,185,129,0.12)]',
    };
  }
  if (p >= 55) {
    return {
      label: `OCR ${p}%`,
      className: 'border border-amber-500/40 bg-amber-500/10 text-amber-100',
    };
  }
  return {
    label: `OCR ${p}%`,
    className: 'border border-rose-500/35 bg-rose-500/10 text-rose-100',
  };
}

export function isAppleMobileUa(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iP(ad|hone|od)/i.test(navigator.userAgent);
}
